<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-oval`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.68069 12.0019C2.68069 8.29013 5.38541 5.09088 9.08599 4.80331C10.1041 4.72419 11.1128 4.67188 12.0002 4.67188C12.8876 4.67188 13.8963 4.72419 14.9145 4.80331C18.615 5.09088 21.3198 8.29013 21.3198 12.0019C21.3198 15.7136 18.615 18.9128 14.9145 19.2004C13.8964 19.2795 12.8876 19.3318 12.0002 19.3318C11.1128 19.3318 10.1041 19.2795 9.08599 19.2004C5.38541 18.9128 2.68069 15.7136 2.68069 12.0019Z" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorOval',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
